
export type TemplatePreviewResponse = {
    components?: unknown;
    data?: string;
    fieldNameAndValueMap?: Record<string, unknown>;
    mediaFileList?: unknown[];
    templateId?: string;
    templateName?: string;
    templateIntegId?: string;
    messageTemplatesEntity?: {
        templateId?: string;
        integId?: string;
        friendlyName?: string;
    } | null;
};

export type ResolvedTemplateMeta = {
    templateId: string;
    templateName?: string;
    templateIntegId?: string;
};

export function getTemplateMetaFromPreviewPayload(
    response: Record<string, unknown> | null | undefined
): ResolvedTemplateMeta | null {
    if (!response) return null;
    const entity = response.messageTemplatesEntity as Record<string, unknown> | undefined | null;
    const templateIdRaw =
        (typeof response.templateId === "string" && response.templateId.trim() !== "" && response.templateId.trim()) ||
        (entity && typeof entity.templateId === "string" && entity.templateId.trim() !== ""
            ? entity.templateId.trim()
            : "");
    if (!templateIdRaw) return null;

    const rootName =
        typeof response.templateName === "string" && response.templateName.trim() !== ""
            ? response.templateName.trim()
            : undefined;
    const templateName =
        rootName ??
        (entity && typeof entity.friendlyName === "string" && entity.friendlyName.trim() !== ""
            ? entity.friendlyName.trim()
            : undefined);

    const templateIntegId =
        (typeof response.templateIntegId === "string" && response.templateIntegId.trim() !== ""
            ? response.templateIntegId.trim()
            : undefined) ||
        (entity && typeof entity.integId === "string" && entity.integId.trim() !== ""
            ? entity.integId.trim()
            : undefined);

    return { templateId: templateIdRaw, templateName, templateIntegId };
}

export function previewHasMergeableContent(response: TemplatePreviewResponse | null): boolean {
    if (response == null) return false;
    if (typeof response.data === "string") return true;
    if (Array.isArray(response.mediaFileList)) return true;
    if (response.components) return true;
    if (response.fieldNameAndValueMap) return true;
    return false;
}
